import { Tc } from '../../../core/_infrastructure/types/common';

export class SolicitudAtestFitoViewModel {
    constructor() {}

    public Id: number;
    public IdUsuarioCa: number | null = null;
    public IdPaisDestino: number;
    public TextoAtestFito: string;
    public TextoAtestFitoUsuarioCaAc: string;
    public FechaCreacion: Date;
    public FechaEnvio: Date | null;
    public FechaFinalizadaCaAc: Date | null;
    public FechaInspeccion: Date | null;
    public IdUsuarioSolicitante: number;
    public IdComunidadAutonoma: number;
    public IdTipoSolicitudInfCa = 0;
    public IdEstado = 0;
    public IdTipoCantidadAtestFito: number | null = null;
    public IdProvincia: number | null = null;
    public PesoTotal: number | null;
    public VolumenTotal: number | null;
    public UnidadesTotal: number | null;
    public RefSolicitante: string;
    public CheckLicencia: boolean;
    public CheckNormativa: boolean;
    public DeclaracionResponsable: boolean;
    public IdUsuarioAgenteControl: number | null = null;
    public SinProductos: boolean;

    public TExportadorSolicitudAtestFito: TExportadorSolicitudAtestFitoViewModel = new TExportadorSolicitudAtestFitoViewModel();
    public TcTipoSolicitudAtestFito: TcTipoSolicitudAtestFitoViewModel = new TcTipoSolicitudAtestFitoViewModel();
    public TcEstadosSolicitudAtestFito: Tc;
    public TClaveSolicitudAtestFito: TClaveSolicitudAtestFitoViewModel;
}

export class TcTipoSolicitudAtestFitoViewModel {
    public Id: number;
    public Descripcion: string;
    public Codigo: string;
}

export class TExportadorSolicitudAtestFitoViewModel {
    public IdSolicitudAtestFito: number;
    public NifExportador: string;
    public NombreExportador: string;
    public CiudadExportador: string;
    public IdPaisExportador: number;
    public DireccionExportador: string;
    public CodigoPostalExportador: string;
}

export class TClaveSolicitudAtestFitoViewModel {
    public IdSolicitudAtestFito: number;
    public RefAtestFito: string;
    public Pin: number;
    public IdPaisDestino: number | null;
    public IdEstadoSolicitudAtest: number;
    public SinProductos: boolean;
    public FechaValidezInicio: Date | null;
    public FechaValidezFin: Date | null;
}

export class ParametrosNuevaSolicitudAtestFitoViewModel {
    public IdTipoSolicitudAtestFito: number;
    public tipoSolicitudAtestFito: string;
    public IdCa: number;
    public IdAc: number;
    public IdProvincia: number;
    public IdPaisDestino: number;
}
